import BakeasyTextField, { BakeasyTextFieldProps } from './BakeasyTextField';
import { useState } from 'react';
import { t } from 'i18next';
import _ from 'lodash';
import * as Regex from '../../constants/Regex';

export function Username(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      type="text"
      name="username"
      maxLength={30}
      disabled={props?.disabled ?? false}
      required={props?.required ?? true}
      value={props?.value}
      label={t('USERNAME')}
      regexPattern={Regex.username}
      placeHolder={t('ENTER') + _.toLower(t('USERNAME'))}
      onChange={props?.onChange}
    />
  );
}

export function Password(props: BakeasyTextFieldProps) {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = (): void => setShowPassword(!showPassword);

  return (
    <BakeasyTextField
      name="password"
      type={showPassword ? 'text' : 'password'}
      maxLength={30}
      value={props?.value}
      showPassword={showPassword}
      required={props?.required ?? true}
      label={props?.label ? props.label : t('PASSWORD')}
      placeHolder={t('ENTER') + _.toLower(t('PASSWORD'))}
      onChange={props?.onChange}
      onIconClick={(event: React.MouseEvent<HTMLButtonElement>) => {
        handleClickShowPassword();
      }}
    />
  );
}

export function EmailId(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      type="email"
      name="email"
      required={props?.required ?? true}
      value={props?.value}
      maxLength={30}
      label={t('EMAIL_ID')}
      regexPattern={Regex.emailId}
      onChange={props?.onChange}
      disabled={props?.disabled}
    />
  );
}

export function AccountingCode(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      label={t('ACCOUNTING_CODE')}
      type="text"
      name="accountingCode"
      required={true}
      value={props?.value}
      maxLength={30}
      regexPattern={Regex.accountingCode}
      onChange={props?.onChange}
      disabled={props?.disabled}
    />
  );
}

export function Work(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      label={t('WORK')}
      type="text"
      name="work"
      required={props?.required ?? true}
      value={props?.value}
      maxLength={10}
      regexPattern={Regex.onlyNumeric}
      onChange={props?.onChange}
      disabled={props?.disabled}
    />
  );
}

export function State(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      required={true}
      label={props?.label ?? t('STATE_PROVINCE')}
      type="text"
      name="supplierState"
      value={props?.value}
      maxLength={props?.maxLength ?? 50}
      onChange={props?.onChange}
      regexPattern={Regex.onlyAlphabets}
      disabled={props?.disabled}
    />
  );
}

export function Pincode(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      required={true}
      label={props?.label ?? t('POSTAL_CODE')}
      type="text"
      name="PinCode"
      value={props?.value}
      // maxLength={props?.maxLength ?? 7}
      maxLength={props?.maxLength}
      onChange={props?.onChange}
      // regexPattern={Regex.postCode}
      regexPattern={props?.regexPattern ?? Regex.postCode}
      disabled={props?.disabled}
      placeHolder={props?.placeHolder}
    />
  );
}

export function Name(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      label={props?.label ?? t('NAME')}
      type="text"
      name="name"
      placeHolder={props?.placeHolder}
      required={props?.required ?? true}
      value={props?.value}
      maxLength={30}
      regexPattern={Regex.name}
      onChange={props?.onChange}
      disabled={props?.disabled ?? false}
    />
  );
}

export function Country(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      required={true}
      label={props?.label ?? t('COUNTRY')}
      type="text"
      name="supplierCountry"
      value={props?.value}
      maxLength={props?.maxLength ?? 50}
      onChange={props?.onChange}
      regexPattern={Regex.onlyAlphabets}
      disabled={props?.disabled}
    />
  );
}

export function City(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      required={true}
      label={props?.label ?? t('CITY')}
      type="text"
      placeHolder={props?.placeHolder}
      name="city"
      value={props?.value}
      maxLength={props?.maxLength ?? 50}
      onChange={props?.onChange}
      regexPattern={Regex.onlyAlphabets}
      disabled={props?.disabled}
    />
  );
}

export function Address(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      required={true}
      label={props?.label ?? t('ADDRESS')}
      type="text"
      name="address"
      value={props?.value}
      maxLength={props?.maxLength ?? 100}
      onChange={props?.onChange}
      placeHolder={props?.placeHolder}
      disabled={props?.disabled}
    />
  );
}

export function Search(props: BakeasyTextFieldProps) {
  function handleIconClick(event: React.MouseEvent<HTMLButtonElement>) {
    if (props.onIconClick) {
      props.onIconClick(event);
    }
  }
  return (
    <BakeasyTextField
      label={t('SEARCH')}
      type="text"
      name="search"
      value={props?.value}
      maxLength={30}
      onChange={props?.onChange}
      onIconClick={(event: React.MouseEvent<HTMLButtonElement>) => {
        handleIconClick(event);
      }}
      onEnterClick={(event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event?.key === 'Enter' && props?.onEnterClick) props?.onEnterClick(event);
      }}
    />
  );
}

export function ParentAddress(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      label={t('PARENT_ADDRESS')}
      type="text"
      name="parentAddress"
      required={true}
      value={props?.value}
      maxLength={30}
      onChange={props?.onChange}
      disabled={props?.disabled}
    />
  );
}

export function Mobile(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      label={t('MOBILE')}
      type="text"
      name="phone"
      required={props?.required ?? true}
      value={props?.value}
      maxLength={14}
      onChange={props?.onChange}
      regexPattern={Regex.mobile}
      disabled={props?.disabled}
      isWorkNumber={true}
    />
  );
}

export function LegalName(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      required={true}
      label={t('LEGAL_NAME')}
      type="text"
      name="legalName"
      value={props?.value}
      maxLength={props?.maxLength ?? 50}
      onChange={props?.onChange}
      regexPattern={Regex.name}
      disabled={props?.disabled}
    />
  );
}

export function LastName(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      label={t('LAST_NAME')}
      type="text"
      name="lastName"
      required={props?.required ?? true}
      value={props?.value}
      maxLength={30}
      onChange={props?.onChange}
      regexPattern={Regex.onlyAlphabets}
      disabled={props?.disabled}
    />
  );
}

export function FirstName(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      label={t('FIRST_NAME')}
      type="text"
      name="firstName"
      required={props?.required ?? true}
      value={props?.value}
      maxLength={30}
      onChange={props?.onChange}
      regexPattern={Regex.onlyAlphabets}
      disabled={props?.disabled}
    />
  );
}

export function SupplierId(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField label={t('SUPPLIER_ID')} disabled={props?.disabled} value={props?.value} />
  );
}

export function StoreId(props: BakeasyTextFieldProps) {
  return <BakeasyTextField label={t('STORE_ID')} disabled={props?.disabled} value={props?.value} />;
}

export function ParentCity(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      required={true}
      label={t('PARENT_CITY')}
      type="text"
      name="parentCity"
      value={props?.value}
      maxLength={props?.maxLength ?? 50}
      onChange={props?.onChange}
      regexPattern={Regex.onlyAlphabets}
      disabled={props?.disabled}
    />
  );
}

export function ParentState(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      required={true}
      label={t('PARENT_STATE')}
      type="text"
      name="parentState"
      value={props?.value}
      maxLength={props?.maxLength ?? 50}
      onChange={props?.onChange}
      regexPattern={Regex.onlyAlphabets}
      disabled={props?.disabled}
    />
  );
}

export function ParentPincode(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      required={true}
      label={t('PARENT_POSTAL_CODE')}
      type="text"
      name="PinCode"
      value={props?.value}
      maxLength={props?.maxLength ?? 6}
      onChange={props?.onChange}
      regexPattern={Regex.onlyNumeric}
      disabled={props?.disabled}
    />
  );
}

export function ParentCountry(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      required={true}
      label={t('PARENT_COUNTRY')}
      type="text"
      name="parentCountry"
      value={props?.value}
      maxLength={props?.maxLength ?? 50}
      onChange={props?.onChange}
      regexPattern={Regex.onlyAlphabets}
      disabled={props?.disabled}
    />
  );
}

export function Description(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      label={props?.label ?? t('DESCRIPTION')}
      type="text"
      name="description"
      multiline
      rows={props?.rows ?? 5}
      required={true}
      value={props?.value}
      maxLength={props?.maxLength ?? 100}
      onChange={props?.onChange}
      disabled={props?.disabled}
      placeHolder={props?.placeHolder}
    />
  );
}

export function Number(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      required={true}
      label={props?.label}
      name="number"
      maxLength={props?.maxLength ?? 2}
      disabled={props?.disabled}
      placeHolder={props?.placeHolder}
      value={props?.value}
      onChange={props?.onChange}
      regexPattern={Regex.onlyNumeric}
    />
  );
}

export function ProductId(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      label={t('PRODUCT_ID')}
      placeHolder={t('ENTER') + t(props?.label ?? '')}
      disabled={props?.disabled}
      onChange={props?.onChange}
      value={props?.value}
    />
  );
}

export function ProductName(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      label={props?.label ?? t('PRODUCT_NAME')}
      placeHolder={t('ENTER') + t(props?.label ?? '')}
      type="text"
      name="name"
      required={props?.required ?? true}
      value={props?.value}
      maxLength={30}
      regexPattern={Regex.name}
      onChange={props?.onChange}
      disabled={props?.disabled ?? false}
    />
  );
}

export function RetailPrice(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      required={true}
      label={t('RETAIL_PRICE')}
      placeHolder={t('ENTER') + t(props?.label ?? '')}
      type="text"
      name="retailPrice"
      value={props?.value}
      maxLength={props?.maxLength ?? 6}
      onChange={props?.onChange}
      regexPattern={Regex.onlyNumeric}
      disabled={props?.disabled}
    />
  );
}

export function GeneralProductCost(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      required={true}
      label={t('GENERAL_PRODUCT_COST')}
      placeHolder={t('ENTER') + t(props?.label ?? '')}
      type="text"
      name="productCost"
      value={props?.value}
      maxLength={props?.maxLength ?? 6}
      onChange={props?.onChange}
      regexPattern={Regex.onlyNumeric}
      disabled={props?.disabled}
    />
  );
}

export function Quantity(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      style={{ height: 30 }}
      label={props?.label}
      name="number"
      type="number"
      maxLength={props?.maxLength ?? 2}
      disabled={props?.disabled}
      placeHolder={t('ENTER') + t(props?.label ?? '')}
      value={props?.value}
      onChange={props?.onChange}
      regexPattern={Regex.onlyNumeric}
    />
  );
}

export function DeActivate(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      required={true}
      label={t('TYPE_DEACTIVATE_HERE')}
      name="deactivate"
      maxLength={10}
      disabled={props?.disabled}
      placeHolder={t('ENTER') + t(props?.label ?? '')}
      fullWidth={true}
      value={props?.value}
      onChange={props?.onChange}
      regexPattern={Regex.onlyAlphabets}
    />
  );
}
export function ReActivate(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      required={true}
      label={t('TYPE_REACTIVATE_HERE')}
      name="reactivate"
      maxLength={10}
      disabled={props?.disabled}
      placeHolder={t('ENTER') + t(props?.label ?? '')}
      fullWidth={true}
      value={props?.value}
      onChange={props?.onChange}
      regexPattern={Regex.onlyAlphabets}
    />
  );
}
export function MessageTo(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      label={t('TO')}
      placeHolder={t('ENTER') + t('NAME')}
      type="text"
      name="name"
      required={true}
      value={props?.value}
      maxLength={30}
      //   regexPattern={Regex.email}
      onChange={props?.onChange}
      disabled={props?.disabled}
    />
  );
}

export function Subject(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      label={t('SUBJECT')}
      placeHolder={props?.placeHolder}
      type="text"
      name="subject"
      required={props?.required ?? true}
      value={props?.value}
      maxLength={50}
      regexPattern={Regex.msgSubject}
      onChange={props?.onChange}
      disabled={props?.disabled ?? false}
    />
  );
}

export function ReplyMessage(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      // label={t('ENTER_MESSAGE')}
      type="text"
      name="replymsg"
      value={props?.value}
      maxLength={500}
      onChange={props?.onChange}
    />
  );
}
